/**
 * Get the parent fieldset element of the input
 * @param {Field} field
 * @returns {HTMLFieldSetElement|boolean}
 */
function getFieldset(field) {
	if (!field) {
		console.log('no field', field);
		return false;
	}

	const fieldset = field.closest('fieldset.field');

	if (!fieldset) {
		console.log('no fieldset', field);
		return false;
	}

	return fieldset;
}

/**
 *
 * @param {Field} field
 * @returns {HTMLButtonElement|false}
 */
function getAddableTabNavLink(field) {
	const addableTabContent = field.closest('.addable-tab-pane');
	if (!addableTabContent) {
		return false;
	}

	return document.getElementById(addableTabContent.getAttribute('aria-labelledby')) || false;
}

/**
 * Removes success/error state from input
 * @param {Field} field
 */
function removeMessage(field) {
	const fieldset = getFieldset(field);
	fieldset.classList.remove('error', 'field--error');
	field.classList.remove('error', 'input--error');

	fieldset.classList.remove('success', 'field--success');
	field.classList.remove('success', 'input--success');

	const errorContainer = fieldset.querySelector('.message-container');
	errorContainer.textContent = '';

	const addableTabNavLink = getAddableTabNavLink(field);
	if (addableTabNavLink) {
		addableTabNavLink.classList.remove('error');
		addableTabNavLink.classList.remove('success');
	}
}

/**
 * Remove all success/errors in form element
 * @param {HTMLFormElement} formElement
 */
function clearAllMessages(formElement) {
	formElement.querySelectorAll('.input--error, .input--success').forEach((field) => removeMessage(field));
}

/**
 * Adds error state to the input
 * @param {Field} field
 * @param {string} message
 */
function addError(field, message) {
	const fieldset = getFieldset(field);
	if (!fieldset) return;
	fieldset.classList.add('error', 'field--error');
	field.classList.add('error', 'input--error');

	const errorContainer = fieldset.querySelector('.message-container');
	errorContainer.textContent = message;

	const addableTabNavLink = getAddableTabNavLink(field);
	if (addableTabNavLink) {
		addableTabNavLink.classList.add('error');
	}
}

/**
 * Adds success state to the input
 * @param {Field} field
 * @param {string} message
 */
function addSuccess(field, message) {
	const fieldset = getFieldset(field);
	if (!fieldset) return;
	fieldset.classList.add('success', 'field--success');
	field.classList.add('success', 'input--success');

	const errorContainer = fieldset.querySelector('.message-container');
	errorContainer.textContent = message;
}

/**
 * Validates single input
 * @param {Field} field
 * @returns {boolean}
 */
function validateField(field) {
	const value = ['checkbox', 'radio'].includes(field?.type) ? field.checked : field.value;

	const isRequired = field.required;
	if (isRequired && !value) {
		addError(field, 'Proszę wypełnić to pole');
		return false;
	}

	const pattern = field.getAttribute('pattern');
	if (value && pattern) {
		const regex = new RegExp(pattern);
		const test = regex.test(value);
		if (!test) {
			addError(field, 'Proszę wypełnić to pole poprawnie');
			return false;
		}
	}

	if (field?.type === 'number') {
		const minValue = parseFloat(field.min);
		const maxValue = parseFloat(field.max);
		const parsedValue = parseFloat(value);
		if (isNaN(parsedValue) || (!isNaN(minValue) && parsedValue < minValue) || (!isNaN(maxValue) && parsedValue > maxValue)) {
			addError(field, 'Proszę wypełnić to pole poprawnie');
			return false;
		}
	}

	return true;
}

/**
 * Validates the form
 * @param {HTMLFormElement} formElement
 * @param {handleTabSwitch} store
 * @returns {boolean}
 */
function validateForm(formElement, store) {
	clearAllMessages(formElement);
	const currentTab = store.getCurrentTab();
	const fieldsToValidate = currentTab.contentElement.querySelectorAll('[name]:invalid:not(.input--inactive)');
	if (fieldsToValidate.length > 0) {
		const [firstInvalidInput] = fieldsToValidate;
		getFieldset(firstInvalidInput).scrollIntoView();
		firstInvalidInput.focus()
	}
	const validationResults = [...fieldsToValidate].map((field) => validateField(field));
	return validationResults.every(Boolean);
}
